"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityConversionTypeToJSON = exports.CommunityConversionTypeFromJSONTyped = exports.CommunityConversionTypeFromJSON = exports.CommunityConversionType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var CommunityConversionType;
(function (CommunityConversionType) {
    CommunityConversionType["FUELINAPP"] = "FUEL_IN_APP";
    CommunityConversionType["FUELONCHAIN"] = "FUEL_ON_CHAIN";
    CommunityConversionType["INDUSTRYPASS"] = "INDUSTRY_PASS";
})(CommunityConversionType = exports.CommunityConversionType || (exports.CommunityConversionType = {}));
function CommunityConversionTypeFromJSON(json) {
    return CommunityConversionTypeFromJSONTyped(json, false);
}
exports.CommunityConversionTypeFromJSON = CommunityConversionTypeFromJSON;
function CommunityConversionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CommunityConversionTypeFromJSONTyped = CommunityConversionTypeFromJSONTyped;
function CommunityConversionTypeToJSON(value) {
    return value;
}
exports.CommunityConversionTypeToJSON = CommunityConversionTypeToJSON;
